import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserActions } from '../state/user'
import { State } from '../types/state'
import { RefreshActions } from '../state/refresh'
import { useRequests } from '../requests/useRequests'

export const FetchDataComponent = (): JSX.Element => {
  const dispatch = useDispatch()
  const requestMaker = useRequests()
  const { shouldRefreshUserState } = useSelector(
    (state: State) => state.refresh
  )

  const fetchUserData = useCallback(async (): Promise<void> => {
    const username = localStorage.getItem('vrema-usernmae')
    const password = localStorage.getItem('vrema-password')
    const token = localStorage.getItem('vrema-jwtToken')
    const googleToken = localStorage.getItem('vrema-googleToken')

    if (token !== null) {
      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    } else if (username !== null && password !== null) {
      const tokenResponse = await requestMaker.getToken({
        username,
        password
      })
      localStorage.setItem('vrema-jwtToken', tokenResponse.data.Authorization)

      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    } else if (googleToken !== null) {
      const tokenResponse = await requestMaker.getToken({
        googleToken
      })
      localStorage.setItem('vrema-jwtToken', tokenResponse.data.Authorization)

      const userDataResponse = await requestMaker.getUserContext()
      dispatch(UserActions.set(userDataResponse.data))
    }
    dispatch(RefreshActions.setUserStateFetched())
  }, [requestMaker, dispatch])

  useEffect(() => {
    if (shouldRefreshUserState) {
      void fetchUserData()
      dispatch(RefreshActions.setUserStateRefreshed())
    }
  }, [shouldRefreshUserState, fetchUserData, dispatch])

  return <></>
}
